import { ReactComponent as SvgMinus } from '@img/icons/range-minus.svg';
import { ReactComponent as SvgPlus } from '@img/icons/range-plus.svg';
import * as React from 'react';
import S from './RangeSlider.styles';
const RangeSlider = ({ value, onChange, ...props }) => {
    const { max, min, step } = props;
    return (React.createElement(S.Container, null,
        React.createElement(S.Button, { "aria-label": "Decrease", type: "button", onClick: (event) => {
                event.preventDefault();
                onChange(Math.max(value - step, min));
            } },
            React.createElement(SvgMinus, null)),
        React.createElement(S.Input, { ...props, max: props.max, min: props.min, step: props.step, type: "range", value: value, onChange: (event) => {
                onChange(parseFloat(event.target.value));
            } }),
        React.createElement(S.Button, { "aria-label": "Increase", type: "button", onClick: (event) => {
                event.preventDefault();
                onChange(Math.min(value + step, max));
            } },
            React.createElement(SvgPlus, null))));
};
export default RangeSlider;
